import React, { memo } from 'react'
import { Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import Alerts from '../alerts'

const useStyles = makeStyles()(() => ({
    paper: {
        height: '100%',
        width: '100%'
    }
}))

function AlertsSidebar() {
    const { classes } = useStyles()
    return (
        <Box className={classes.paper}>
            <Alerts />
        </Box>
    )
}

export default memo(AlertsSidebar)
